import { render, staticRenderFns } from "./EdgeForm.vue?vue&type=template&id=32d10694"
import script from "./EdgeForm.vue?vue&type=script&lang=js"
export * from "./EdgeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports